import { Routes } from '@angular/router';
import { OrganizationListComponent } from './admin/organization/organization.list.component';
import { SpaceFacilityListComponent } from './admin/space.facility/space.facility.list.component';
import { SpaceTypeListComponent } from './admin/space.type/space.type.list.component';
import { UserListComponent } from './admin/user/user.list.component';
import { BookingMainComponent } from './booking/booking.main.component';
import { HomeComponent } from './home.component';
import { LangComponent } from './lang.component';
import { LoginErrorPage } from './login.error.page';
import { LoginPage } from './login.page';
import { AgentListComponent } from './manage/agent/agent.list.component';
import { DeviceListComponent } from './manage/device/device.list.component';
import { EventListComponent } from './manage/event/event.list.component';
import { LocationListComponent } from './manage/location/location.list.component';
import { LockerListComponent } from './manage/locker/locker.list.component';
import { SpaceListComponent } from './manage/space/space.list.component';
import { NotFoundPage } from './notfound.page';
import { SpaceWizardPage } from './space.wizard.page';
import { SSOErrorPage } from './sso.error.page';
import { TermsPage } from './terms.page';
import { BookingInviteConfirmPage } from './user/booking.invite.confirm.page';
import { BookingInviteExceededPage } from './user/booking.invite.exceeded.page';
import { BookingInviteLandingPage } from './user/booking.invite.landing.page';
import { BookingInvitePage } from './user/booking.invite.page';
import { LocationMapPage } from './user/location.map.page';
import { LocationPage } from './user/location.page';
import { LocationSearchPage } from './user/location.search.page';
import { LockerBookPage } from './user/locker.book.page';
import { LockerPage } from './user/locker.page';
import { LockerSearchPage } from './user/locker.search.page';
import { MyBookingCompletedPage } from './user/my.booking.completed.page';
import { MyBookingListPage } from './user/my.booking.list.page';
import { MyBookingPage } from './user/my.booking.page';
import { MyWishlistPage } from './user/my.wishlist.page';
import { ProfilePage } from './user/profile.page';
import { QRCodePage } from './user/qrcode.page';
import { SpaceBookPage } from './user/space.book.page';
import { SpacePage } from './user/space.page';
import { SpaceSearchPage } from './user/space.search.page';
import { SpaceWizardResultPage } from './user/space.wizard.result.page';

export const route_map: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'terms', component: TermsPage },


  { path: 'sso-error', component: SSOErrorPage },
  { path: 'login', component: LoginPage },
  { path: 'login-error', component: LoginErrorPage },
  { path: 'manage/location', component: LocationListComponent },
  { path: 'manage/space', component: SpaceListComponent },
  { path: 'manage/locker', component: LockerListComponent },
  { path: 'manage/event', component: EventListComponent },
  { path: 'manage/booking', component: BookingMainComponent },
  { path: 'manage/device', component: DeviceListComponent },
  { path: 'manage/agent', component: AgentListComponent },
  { path: 'admin/user', component: UserListComponent },
  { path: 'admin/organization', component: OrganizationListComponent },
  { path: 'admin/space-type', component: SpaceTypeListComponent },

  { path: 'admin/space-facility', component: SpaceFacilityListComponent },

  // user view
  { path: 'space-search', component: SpaceWizardPage },
  { path: 'space-search-result', component: SpaceWizardResultPage },

  { path: 'space', component: SpaceSearchPage },
  { path: 'space/:id', component: SpacePage },
  { path: 'space/:id/book', component: SpaceBookPage },

  { path: 'locker', component: LockerSearchPage },
  { path: 'locker/:id', component: LockerPage },
  { path: 'locker/:id/book', component: LockerBookPage },

  { path: 'location-search', component: LocationSearchPage },
  { path: 'location', component: LocationMapPage },
  { path: 'location/:id', component: LocationPage },
  { path: 'event', component: EventListComponent },
  { path: 'invite/:code', component: BookingInvitePage, },
  { path: 'invite-detail/:code/login', component: BookingInviteLandingPage, },
  { path: 'invite-detail/:code/confirm', component: BookingInviteConfirmPage, },
  { path: 'invite-detail/:code/exceeded', component: BookingInviteExceededPage, },


  { path: 'my/qrcode', component: QRCodePage },
  { path: 'my/booking/:id', component: MyBookingPage },
  { path: 'my/booking/:id/completed', component: MyBookingCompletedPage },
  { path: 'my/booking', component: MyBookingListPage },
  { path: 'my/profile', component: ProfilePage },
  { path: 'my/wishlist', component: MyWishlistPage },

  { path: 'notfound', component: NotFoundPage },
];

export const routes: Routes = [
  {
    path: 'en',
    component: LangComponent,
    data: {
      lang: 'en',
    },
    children: route_map,
  },
  {
    path: 'zh_hk',
    component: LangComponent,
    data: {
      lang: 'zh_hk',
    },

    children: route_map,
  },
  {
    path: 'zh_cn',
    component: LangComponent,
    data: {
      lang: 'zh_cn',
    },

    children: route_map,
  },
  ...route_map,
];
